import Swiper from "swiper"
import { find } from "../utils/dom"
import { initHeroVideos, initLazyVideos } from "../modules/lazyVideo"
import { getLazyImages } from "../modules/lazyImage"

export default function () {
	const Home = find("[js-page='home']")
	if (!Home) return

	initHeroVideos('.js-hero-video')
	initLazyVideos('.js-lazy-video')

	var swiperTeam = new Swiper(".swiper-team-top-new", {
			slidesPerView:'auto',
			spaceBetween:8,
      navigation: {
        nextEl: ".swiper-team-button-next",
        prevEl: ".swiper-team-button-prev",
      },
    });

		var swiperTeamBottom = new Swiper(".swiper-team-bottom-new", {
			slidesPerView:'auto',
			spaceBetween:8,
			slidesOffsetBefore:24,
			pagination:{
				el: ".swiper-pagination",
        clickable: true,
				renderBullet: function (index, className) {
					if (index < 8) {
						return `<span class="${className}"></span>`;
					}
					return '';
				}
			},
      navigation: {
        nextEl: ".swiper-team-button-next",
        prevEl: ".swiper-team-button-prev",
      },
    });

	const rescanLazyImages = (root) => getLazyImages()?.scan(root || document)

	const clickFilterTeam = (swiper) => {
		const cardsTeamTop = document.querySelectorAll('.card-team-top')
		const allSlides = Array.from(swiper.slides)
  	const emptyMessage = document.getElementById('empty-message')

		cardsTeamTop.forEach(card => {
			card.addEventListener('click', () => {

				cardsTeamTop.forEach(c => c.classList.remove('active'))
				card.classList.add('active')

				const categoria = card.dataset.categoriaCargo
				swiper.removeAllSlides()

				const slidesToShow = categoria === 'todos'
					? allSlides
					: allSlides.filter(slide => slide.dataset.categoriaCargoPeople === categoria)

				if(slidesToShow.length === 0){
					emptyMessage.classList.toggle('hidden')
				} else {
					emptyMessage.classList.add('hidden')
					swiper.appendSlide(slidesToShow)
				}
				swiper.update()
				rescanLazyImages(swiper.el)
			})
		})
	}

	clickFilterTeam(swiperTeamBottom)
	const teamSwiperEl = document.querySelector('.swiper-team-bottom-new')

	const bindLazyCarousels = () => {
		if (!window.jQuery) return
		window.jQuery('.carousel-logos-1, .owl-depoimentos').on(
			'initialized.owl.carousel refreshed.owl.carousel translated.owl.carousel',
			function () {
				rescanLazyImages(this)
			}
		)
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', bindLazyCarousels, { once: true })
	} else {
		bindLazyCarousels()
	}

	document.querySelectorAll('.menu-tabs a').forEach((link) => {
		link.addEventListener('click', () => {
			const tabId = link.getAttribute('href')
			setTimeout(() => {
				const tab = tabId ? document.querySelector(tabId) : null
				if (tab) rescanLazyImages(tab)
			}, 350)
		})
	})

	swiperTeamBottom.on('slideChange slideChangeTransitionEnd', () => {
		if (teamSwiperEl) rescanLazyImages(teamSwiperEl)
	})
}